import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { AudioBriefingsPopupListenPanel } from './AudioBriefingPopupListenPanel';
import { AudioBriefingPopupCustomizePanel } from './AudioBriefingPopupCustomizePanel';

const i18n = defineMessages({
	listenTab: {
		id: 'audio.audio-briefing-popup.listen-tab',
		defaultMessage: 'Listen',
		description:
			'The name of the tab in the audio briefing popup that directs towards the miniplayer to listen to audio',
	},
	customizeTab: {
		id: 'audio.audio-briefing-popup.customize-tab',
		defaultMessage: 'Customize',
		description:
			'The name of the tab in the audio briefing popup that directs towards the customization panel',
	},
});

import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { ONBOARDING_INSIGHTS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

import { AudioBriefingChangeboarding } from './AudioBriefingChangeboarding';

const styles = cssMap({
	wrapper: {
		width: '300px',
		height: '272px',
	},
	tabList: {
		marginBottom: token('space.150'),
		marginTop: token('space.150'),
	},
});

export const AudioBriefingPopupContent = () => {
	const { formatMessage } = useIntl();

	const { data: onboardingStateData, loading: onboardingStateLoading } = useGetOnboardingState(
		ONBOARDING_INSIGHTS.AUDIO_BRIEFING,
	);

	const { hasAudioBriefingChangeboardingBeenSeen } = deserializeState(onboardingStateData);

	if (onboardingStateLoading) {
		return <Box xcss={styles.wrapper} padding="space.100" />;
	}

	if (!hasAudioBriefingChangeboardingBeenSeen) {
		return (
			<Box xcss={styles.wrapper} padding="space.100">
				<AudioBriefingChangeboarding />
			</Box>
		);
	}

	return (
		<Box xcss={styles.wrapper} padding="space.200">
			<Tabs id="audio-tabs">
				<Box xcss={styles.tabList}>
					<TabList>
						<Tab>{formatMessage(i18n.listenTab)}</Tab>
						<Tab>{formatMessage(i18n.customizeTab)}</Tab>
					</TabList>
				</Box>
				<TabPanel>
					<AudioBriefingsPopupListenPanel />
				</TabPanel>
				<TabPanel>
					<AudioBriefingPopupCustomizePanel />
				</TabPanel>
			</Tabs>
		</Box>
	);
};
